import React from "react";
import { RFQ_STATUS, ORDER_STATUSES } from "./status";

const StatusBadge = ({ status, type = "rfq" }) => {
  const statusMap =
    type === "order" ? ORDER_STATUSES : RFQ_STATUS;

  const statusObj = statusMap?.[Number(status)] || {
    label: "Unknown",
    color: "#ECEFF1",
  };

  return (
    <span
      style={{
        backgroundColor: statusObj.color,
        color: "#333",
        padding: "4px 10px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {statusObj.label}
    </span>
  );
};

export default StatusBadge;
